"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cell = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./Cell.scss");
const Cell = _ref => {
  let {
    className,
    colspan,
    mobileLabel,
    mobileOrder,
    value
  } = _ref;
  const isValueEmpty = typeof value === 'string' && value.trim() === '' || value === undefined || value === null;
  const rootClassName = (0, _classnames.default)('cds-DataTable-BodyCell', {
    [`cds-DataTable-BodyCell--MobileOrder${mobileOrder || 0}`]: mobileOrder !== undefined,
    'cds-DataTable-BodyCell--EmptyValue': isValueEmpty
  }, className);
  return /*#__PURE__*/_react.default.createElement("td", {
    className: rootClassName,
    colSpan: colspan,
    "data-mobile-label": mobileLabel,
    title: typeof value === 'string' ? value : undefined
  }, value);
};
exports.Cell = Cell;
//# sourceMappingURL=Cell.js.map